module.exports = __webpack_public_path__ + "img/wein-wissen-desktop.39a97b30.jpg";